import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { StatusInfoOfOrderItemStatus } from './StatusInfoOfOrderItemStatus'
import { OrderItemCancelledReason } from './Enums'
/**
* Class OrderItemInstanceShorDto
*  Информация по отдельной позиции продукта в заказе
*/
export class OrderItemInstanceShorDto extends ActiveModel {

  /**
  * currentStatus
  * Информация о статусе  */
  @ActiveField({
    factory: [StatusInfoOfOrderItemStatus, () => StatusInfoOfOrderItemStatus.create()]
  })
  currentStatus: StatusInfoOfOrderItemStatus = StatusInfoOfOrderItemStatus.create()


  /**
  * cancelledReason
  * Известная причина отмены позиции заказа<br>  */
  @ActiveField(undefined)
  cancelledReason: null | OrderItemCancelledReason = undefined
}
